// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b10b788f","453":"780908d9","455":"ae9e2417","977":"1ee99ab2"}[chunkId] + ".chunk.js";
};